import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CORPACT_CA_ADMIN_PAYMENT_BASE_PATH } from '../../../../../../../../../features/corporate-action/ca-admin/payment/ca-admin-payment-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'corporate-actions-payment-list',
        label: 'Corporate Actions',
        to: CORPACT_CA_ADMIN_PAYMENT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
